export default __webpack_public_path__ + "static/media/dinner.5b1215c3.jpg";